'use strict'

/**
 * 常用后端API
 */
import { getRequest, putRequest } from 'utils/http-service'
import { formatTimeInSec, constructPlotFullName } from 'utils/utils'
import {
  URL_CROPS_ROTATION_META,
  URL_AVAILABLE_CROPS_ROTATION_META,
  URL_CROPS_GROWTH_STAGE_META,
  URL_SERVICE_TYPE_META,
  URL_COLLECT_RULE_COMPANY,
  URL_EVER_COLLECTED_INDICATOR_LAST_VALUE,
  URL_BASE_MANAGEMENT_LIST,
  URL_COCKPIT_STATISTIC_FARM_LIST,
  URL_INDICATOR_HISTORY_VALUE_AND_EVALUATION,
  URL_USER,
  URL_PLOT_COLLECTION_AND_VALUE_BY_TYPE,
  URL_PLOT_WITH_BOUNDARY,
  URL_PLOT_BOUNDARY,
  URL_OFFICIAL_COMPANY,
  URL_BOSS_OF_COMPANY,
  URL_FARM,
  URL_PLOT_WITH_FARM_FARMER,
  URL_PLOT_GROWTH_STAGE,
  URL_COLLECTIONS,
  URL_FROST_TEMPERATURE,
  URL_GET_FIELD_PATROL_RESULTS,
  URL_PETIOLE_INDICATOR_EVALUATION,
  URL_PETIOLE_INDICATOR_EVALUATION_MULTI_PLOTS,
  URL_GROWTH_INDICATOR_EVALUATION,
  URL_PLOT_LIST,
  UEL_PLOT_SUMMARY_WITH_GROW_STAGE,
  URL_PLOT_SEEDING_PREDICT,
  URL_SATELLITE_IMAGE,
  URL_COLLECT_DENSITY_CENTER
} from '../constants/url'

/**
 * 获取所有茬口的定义。
 * 成功时回调的数据结构为 { id, name }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchCropsRotationMeta = function (that, callback) {
  that.isLoading = true
  getRequest(URL_CROPS_ROTATION_META)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchCropsRotationMeta() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询茬口失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data || res.data.length === 0) {
        callback.onFail('查询茬口失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.sort((a, b) => b.cropRotationID - a.cropRotationID)
      res.data.forEach(function (cropRotationDto) {
        dataVo.push({
          id: cropRotationDto.cropRotationID,
          name: cropRotationDto.cropRotationName || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchCropsRotationMeta() fail', err)
      callback.onFail(err.message || '查询茬口失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取所有有权限查看的地块对应的茬口。
 * 成功时回调的数据结构为 { id, name }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchAvailableCropsRotation = function (that, callback) {
  that.isLoading = true
  getRequest(URL_AVAILABLE_CROPS_ROTATION_META)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchAvailableCropsRotation() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询茬口失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data || res.data.length === 0) {
        callback.onFail('查询茬口失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.sort((a, b) => b.cropRotationID - a.cropRotationID)
      res.data.forEach(function (cropRotationDto) {
        dataVo.push({
          id: cropRotationDto.cropRotationID,
          name: cropRotationDto.cropRotationName || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchAvailableCropsRotation() fail', err)
      callback.onFail(err.message || '查询茬口失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询指定地块在指定时间段内，所有采集过的指标项的最近一次指标值。
 * params { plotId, startTimeStamp, endTimeStamp, withSoilTextureUnconditionally(非必须) }
 */
const fetchLatestValues4AllEverCollectedIndicator = function (that, params, callback) {
  that.isLoading = true
  getRequest(URL_EVER_COLLECTED_INDICATOR_LAST_VALUE, params)
    .then(res => {
      that.isLoading = false
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      callback.onSucc(res.data)
    }).catch(err => {
      that.isLoading = false
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取指定茬口下，有权限查看的地块所属的基地列表。
 * @param params { rotationId }
 * @return [{id, orgName, companyId}]
 */
const fetchFarmListWithPlotAuthorization = function (params, callback) {
  getRequest(URL_BASE_MANAGEMENT_LIST, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取指定茬口下，有权限查看的地块所属的基地列表。
 *
 * @param params { rotationId }
 * @return [{id, orgName, companyId, plotList:[{id, name, plotMgmtID, variety: {id, nameCn, nameEn}, growthStageList:[{growthStageID, startTimestamp, endTimestamp}] }] }]
 */
const fetchFarmListWithVarietyStagePlotAuthorization = function (params, callback) {
  getRequest(URL_COCKPIT_STATISTIC_FARM_LIST, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

// 圈地块列表
const fetchPlotListWithBoundary = function (that, params, callback) {
  that.isLoading = true
  getRequest(URL_PLOT_WITH_BOUNDARY, params)
    .then(res => {
      that.isLoading = false
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      that.isLoading = false
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

const fetchfrostTemperature = function (that, params, callback) {
  that.isLoading = true
  getRequest(URL_FROST_TEMPERATURE, params).then(res => {
    that.isLoading = false
    if (res.code !== 0) {
      callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
      return
    }

    callback.onSucc(res.data)
  }).catch(err => {
    that.isLoading = false
    callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
  })
}

// 修改圈地
const updateFieldBoundary = function (that, params, callback) {
  putRequest(URL_PLOT_BOUNDARY, params)
    .then(res => {
      console.log(callback)
      if (res.code !== 0) {
        callback.onFail(res.message || '提交失败，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      that.isLoading = false
      callback.onFail(err.message || '提交失败，请稍后重试！')
    })
}

// 播种时间预测
const fetchPlantingTimeSuggestion = function (params, callback) {
  getRequest(URL_PLOT_SEEDING_PREDICT, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }
      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取地块及其采集日期列表
 * @param params.rotationID 茬口ID，必填
 * @param params.dbxOrgId 组织节点ID，必填
 * @param params.indicatorGroup 采集指标分组，可选。100 叶柄，200 土壤，300 灌溉水，400 体征
 */
const fetchPlotWithCollectDateList = function (params, callback) {
  getRequest(URL_PLOT_LIST, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询指定地块、指定采集类型的采集记录及其指标值。
 *
 * @param params {
 *   plotIDs // 地块ID，多个ID用英文逗号分隔，必须
 *   collectMode // 田间调查 1，样本送检 2
 *   indicatorGroup // 100叶柄，200土壤，300水源，400体征
 *   fromTimestamp // 采集记录起始毫秒时间戳，必须
 *   toTimestamp // 采集记录截止毫秒时间戳，必须
 * }
 * @return key为plotID，形如：
 * "20515": [{
 *       "collect": {
 *         "id": 89179,
 *         "collectTimestamp": 1713004784672, // 采集时间戳
 *         "testingCode": "23199389",
 *         "testResultSubmitTimestamp": 1713348061164 // 检测完成时间戳
 *       },
 *       "indicatorValueList": [{
 *           "indicatorID": 273,
 *           "indicatorValue": 7.99, // 实际检测值
 *           "normValueUnder5Levels": 3.245 // 五级归一化值，可能不存在
 *         },
 *         ......
 *       ]
 *     },
 *     ......
 *   ]
 */
const fetchPlotCollectionValueByCollectType = function (params, callback) {
  getRequest(URL_PLOT_COLLECTION_AND_VALUE_BY_TYPE, params)
    .then(res => {
      if (!res.data) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}
/**
 * 获取指定地块在指定截止时间之前，采集过的指定指标项的所有指标值和评价。
 * 参数 { plotId, indicatorId, endTimeStamp }
 * 成功时回调的数据结构为 [{
 *  indicatorId, indicatorValue, indicatorName, shortNameCn, shortNameEn, unitCn, unitEn, evaluation, collectMonthDay
 * }]
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchIndicatorHistoryValueAndEvaluation = function (that, params, callback) {
  if (params && params.loadingVar) {
    that[params && params.loadingVar] = true
  }
  getRequest(URL_INDICATOR_HISTORY_VALUE_AND_EVALUATION, params)
    .then(res => {
      if (params && params.loadingVar) {
        that[params && params.loadingVar] = false
      }

      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      if (params && params.loadingVar) {
        that[params && params.loadingVar] = false
      }
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取地块摘要信息及进入各生育期的日期。
 * 成功时回调的数据结构为 {
 *  id, location(String),
 *  boundry(String), // 经纬度范围
 *  leaderId, // 种植户id
 *  userName, // 种植户
 *  orgName, // 基地
 *  sowTimestamp, // 播种日期
 *  area; // 面积, 亩
 *  seedling; // 出苗日期
 *  stem_developing; // 块茎形成日期
 *  tuber_bulking; // 块茎膨大日期
 * }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchPlotSummaryWithGrowthStage = function (params, callback) {
  getRequest(UEL_PLOT_SUMMARY_WITH_GROW_STAGE, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取所有生育期的定义。
 * 成功时回调的数据结构为 { id, name }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchGrowthStageMeta = function (that, callback) {
  that.isLoading = true
  getRequest(URL_CROPS_GROWTH_STAGE_META)
    .then(res => {
      that.isLoading = false

      if (res.code !== 0) {
        callback.onFail(res.message || '查询生育期选项失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data || res.data.length === 0) {
        callback.onFail('查询生育期选项失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.forEach(function (growthPeriodDto) {
        dataVo.push({
          id: growthPeriodDto.id,
          name: growthPeriodDto.name || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      callback.onFail(err.message || '查询生育期选项失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取所有服务类型的定义。
 * 成功时回调的数据结构为 { id, name }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchServiceTypeMeta = function (that, callback) {
  that.isLoading = true
  getRequest(URL_SERVICE_TYPE_META)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchServiceTypeMeta() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询服务类型选项失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data || res.data.length === 0) {
        callback.onFail('查询服务类型选项失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.forEach(function (serviceTypeDto) {
        dataVo.push({
          id: serviceTypeDto.code,
          name: serviceTypeDto.summaryCN || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchServiceTypeMeta() fail', err)
      callback.onFail(err.message || '查询服务类型选项失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取所有有采集规范的公司。
 * 成功时回调的数据结构为 { id, name }
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchCollectRuleCompanies = function (that, callback) {
  that.isLoading = true
  getRequest(URL_COLLECT_RULE_COMPANY)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchCollectRuleCompanies() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询采集类型公司选项失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data || res.data.length === 0) {
        callback.onFail('查询采集类型公司选项失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.forEach(function (companyDto) {
        dataVo.push({
          id: companyDto.id,
          name: companyDto.name || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchCollectRuleCompanies() fail', err)
      callback.onFail(err.message || '查询采集类型公司选项失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询地茬及薯农信息。
 * 如果符合条件的空地茬已有对应的非空地茬，即已添加过播种区域，则空地茬被排除在结果之外。
 * 成功时回调的数据结构为 [{ plot: {id, name, fullName, sowTimestamp, emergenceTimestamp, varietyID, varietyName, varietyNameEnAbbr }, farm: {id, name}, farmer: {userID, userName}}]
 *
 * @param params {
 *  cropRotationID, plotIDs, plotName, companyIDs, excludeCompanyIDs, pageNumber, pageSize
 * }
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchPlotAndFarmer = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchPlotAndFarmer() params ', params)
  params.excludeCompanyIDs = (params.excludeCompanyIDs ? params.excludeCompanyIDs + ',' : '') +
    '10001,10011,10021,10031,10041,10051' // 排除体验公司的地块

  getRequest(URL_PLOT_WITH_FARM_FARMER, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchPlotAndFarmer() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '服务器异常，请稍后重试！')
        return
      }
      if (!Array.isArray(res.data.pageData) || res.data.pageData.length === 0) {
        callback.onSucc([])
        return
      }

      res.data.pageData.forEach(plotWithFarmFarmer => {
        if (!plotWithFarmFarmer.farm) {
          plotWithFarmFarmer.farm = { id: -999, name: '未知基地' }
        }
        if (!plotWithFarmFarmer.farmer) {
          plotWithFarmFarmer.farmer = { id: -999, name: '未知农户' }
        }
        plotWithFarmFarmer.plot.fullName = constructPlotFullName(plotWithFarmFarmer.farmer.userName, plotWithFarmFarmer.farm.name,
          plotWithFarmFarmer.plot.name, plotWithFarmFarmer.plot.varietyName)
        if (!isNaN(plotWithFarmFarmer.plot.varietyID) && plotWithFarmFarmer.plot.varietyID > 0) {
          if (plotWithFarmFarmer.plot.varietyID === 47) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'RB'
          } else if (plotWithFarmFarmer.plot.varietyID === 48) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'IN'
          } else if (plotWithFarmFarmer.plot.varietyID === 50) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'Atlantic'
          } else if (plotWithFarmFarmer.plot.varietyID === 51) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'IR'
          } else if (plotWithFarmFarmer.plot.varietyID === 18) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'Lucinda'
          } else if (plotWithFarmFarmer.plot.varietyID === 77) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'Farida'
          } else if (plotWithFarmFarmer.plot.varietyID === 4) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'XiSen6'
          } else if (plotWithFarmFarmer.plot.varietyID === 93) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'WoTu5'
          } else if (plotWithFarmFarmer.plot.varietyID === 95) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = '9N11'
          } else if (plotWithFarmFarmer.plot.varietyID === 2) {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = 'Favorita'
          } else {
            plotWithFarmFarmer.plot.varietyNameEnAbbr = plotWithFarmFarmer.plot.varietyName
          }
        }
      })

      res.data.pageData.sort((l, r) => {
        const companyComparision = (l.plot.userCompanyID + '').localeCompare(r.plot.userCompanyID + '')
        if (companyComparision !== 0) {
          return companyComparision
        }
        return l.plot.fullName.localeCompare(r.plot.fullName)
      })
      callback.onSucc(res.data.pageData || [])
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchPlotAndFarmer() err', err)
      callback.onFail(err.message || '服务器异常，请稍后重试！')
    })
}

/**
 * 查询地块的生育期，按生育期发生先后排序，早的在先。
 * 成功时回调的数据结构为 {
 *  plotID: [{ plotID, growthStageID, startTimestamp, endTimestamp, growthPeriodBeginDate, growthPeriodEndDate }]
 * }
 *
 * @param params { plotIDs }
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchPlotPassedGrowthStageList = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchPlotPassedGrowthStageList() params ', params)

  getRequest(URL_PLOT_GROWTH_STAGE, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchPlotPassedGrowthStageList() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '服务器异常，请稍后重试！')
        return
      }

      let plotPassedGrowthPeriodMap = {}
      Object.keys(res.data).forEach(plotID => {
        let plotPassedGrowthPeriodList = [];

        (res.data[plotID] || []).forEach(growthPeriod => {
          plotPassedGrowthPeriodList.push({
            plotID: growthPeriod.plotID,
            growthStageID: growthPeriod.growthStageID,
            startTimestamp: growthPeriod.startTimestamp,
            endTimestamp: growthPeriod.endTimestamp,
            growthPeriodBeginDate: formatTimeInSec(growthPeriod.startTimestamp / 1000, 'yyyy年MM月dd日'),
            growthPeriodEndDate: growthPeriod.endTimestamp >= 4092566400000 ? '-' : formatTimeInSec(growthPeriod.endTimestamp / 1000, 'yyyy年MM月dd日')
          })
        })

        plotPassedGrowthPeriodMap[plotID] = plotPassedGrowthPeriodList
      })

      console.log(that.$route.name + ' fetchPlotPassedGrowthStageList() plotPassedGrowthPeriodMap', plotPassedGrowthPeriodMap)
      callback.onSucc(plotPassedGrowthPeriodMap)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchPlotPassedGrowthStageList() err', err)
      callback.onFail(err.message)
    })
}

/**
 * 查询人员信息。
 * 成功时回调的数据结构为 [{ id, name, phone, secondaryPhone, type, companyID }]
 *
 * @param params 所有字段均为选填 {
 *          name, phone, // 按姓名或电话号码模糊搜索
 *          type, // 1 正式人员; 2 体验人员。可按位或
 *          companyIDs, excludeCompanyIDs, // 包含和剔除哪些公司的人员
 *          pageNumber, pageSize // 页码, 1-based
 *        }
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchUser = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchUser() params ', params)

  getRequest(URL_USER, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchUser() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询用户信息失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data.pageData || res.data.pageData.length === 0) {
        callback.onFail('查询用户信息失败，服务器异常，请稍后重试！')
        return
      }

      let dataVo = []
      res.data.pageData.forEach(function (userDto) {
        dataVo.push({
          id: userDto.userID,
          name: userDto.userName || '',
          phone: userDto.userPhone || '',
          secondaryPhone: userDto.userSecondaryPhone || '',
          type: userDto.userType || '',
          companyID: userDto.userCompanyID || ''
        })
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchUser() fail', err)
      callback.onFail(err.message || '查询用户信息失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询有权限查看的正式公司列表。
 * 成功时回调的数据结构为 [{id, name}] 公司ID和公司名称
 *
 * @param params 无需参数。
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchOfficialCompany = function (that, params, callback) {
  that.isLoading = params && params.showLoading
  console.log(that.$route.name + ' fetchOfficialCompany() params ', params)

  getRequest(URL_OFFICIAL_COMPANY, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchOfficialCompany() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询公司失败，服务器异常，请稍后重试！')
        return
      }

      let companyArrayVo = [];
      (res.data || []).forEach(companyDto => {
        if (companyDto.id !== 9) { // 排除表示"系统"的公司
          companyArrayVo.push({
            id: companyDto.id || '',
            name: companyDto.name || ''
          })
        }
      })

      callback.onSucc(companyArrayVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchOfficialCompany() fail', err)
      callback.onFail(err.message || '查询公司失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询公司老板信息。
 * 成功时回调的数据结构为 { // key 为 companyID, value 为老板的用户信息
 *  '13358': { id, name, phone, secondaryPhone, type, companyID }
 * }
 *
 * @param params companyIDs 待查询的公司的ID列表，英文半角逗号分隔。
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchBossOfCompany = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchBossOfCompany() params ', params)

  getRequest(URL_BOSS_OF_COMPANY, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchBossOfCompany() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询老板信息失败，服务器异常，请稍后重试！')
        return
      }

      let companyID2Boss = res.data
      let dataVo = {};
      (Object.keys(companyID2Boss) || []).forEach(function (companyID) {
        let bossDto = companyID2Boss[companyID]
        dataVo[companyID] = {
          id: bossDto.userID,
          name: bossDto.userName || '',
          phone: bossDto.userPhone || '',
          secondaryPhone: bossDto.userSecondaryPhone || '',
          type: bossDto.userType || '',
          companyID: bossDto.userCompanyID || ''
        }
      })

      callback.onSucc(dataVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchBossOfCompany() fail', err)
      callback.onFail(err.message || '查询老板信息失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询符合条件的有权限查看的基地列表。
 * 成功时回调的数据结构为 [{id, name, companyID}] 基地ID、名称和所属公司ID
 *
 * @param params companyID 若不指定，则查询所有有权限的基地。
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchFarm = function (that, params, callback) {
  that.isLoading = params && params.showLoading
  console.log(that.$route.name + ' fetchFarm() params ', params)

  getRequest(URL_FARM, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchFarm() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询基地失败，服务器异常，请稍后重试！')
        return
      }

      let farmArrayVo = [];
      (res.data || []).forEach(farmDto => {
        farmArrayVo.push({
          id: farmDto.id || '',
          name: farmDto.name || '',
          companyID: farmDto.companyID || ''
        })
      })

      callback.onSucc(farmArrayVo)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchFarm() fail', err)
      callback.onFail(err.message || '查询基地失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询采集记录。
 * 成功时回调的数据结构为 [{ id, name, phone, secondaryPhone, type, companyID }]
 *
 * @param params 所有字段均为选填 {
 *          name, phone, // 按姓名或电话号码模糊搜索
 *          type, // 1 正式人员; 2 体验人员。可按位或
 *          companyIDs, excludeCompanyIDs, // 包含和剔除哪些公司的人员
 *          pageNumber, pageSize // 页码, 1-based
 *        }
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
function _convertIndicatorCollectDto2Vo (dtoList, pageNumber, pageSize) {
  let that = this
  let vo = []
  let tableRowNode4Merge = []
  let tableRowNode4PlantColumnMerge = []

  dtoList.forEach((dto, dtoIdx) => {
    let photos = [];
    (dto.photos || []).forEach((photo, idx) => {
      photos.push({ url: photo, index: idx })
    })

    let collectPhotos = [];
    (dto.photos || []).forEach((photo, idx) => {
      collectPhotos.push({ url: photo, index: idx })
    })

    let overviewPhotos = [];
    (dto.overviewPhotos || []).forEach((photo, idx) => {
      overviewPhotos.push({ url: photo, index: idx })
    })

    tableRowNode4Merge.push({
      startRowIndex: vo.length,
      needTobeMergedRowCount: dto.indicatorValues.length
    })

    let indicatorValues = []
    let unionindicatorValues = [];
    (dto.indicatorValues || []).forEach(item => {
      let underlyingValuesDesc = ''
      let underlyingValues = []
      let indicatorItem = {}
      if (item.underlyingIndicatorValues) {
        underlyingValuesDesc = ' ('
        for (let key in item.underlyingIndicatorValues) {
          let underlyingValue = item.underlyingIndicatorValues[key]

          underlyingValues.push({underlyingValueID: key, underlyingValue: underlyingValue})

          if (underlyingValuesDesc.length > 2) {
            underlyingValuesDesc += ', '
          }
          underlyingValuesDesc += underlyingValue
        }
        underlyingValuesDesc += ')'
      }

      indicatorItem = {
        indicatorName: item.indicatorName,
        indicatorValue: item.indicatorValue,
        indicatorValueID: item.indicatorValueID,
        unit: item.unit,
        underlyingIndicatorValues: underlyingValues,
        indicatorDisplayText: item.indicatorName ? (item.indicatorName + '：' + item.indicatorValue + item.unit + underlyingValuesDesc) : '',
        editable: item.editable,
        factorValue: Number(item.factorValue)
      }

      if (item.standalone) {
        let photos = []
        let photoUrls = [];
        (item.photos || []).forEach((photo, idx) => {
          photos.push({
            url: photo + '/resize,w_1260/quality,q_90',
            thumbUrl: photo + '/resize,w_100',
            index: idx
          })
          photoUrls.push(photo + '/resize,w_1260/quality,q_90')
        })

        indicatorItem.photos = photos
        indicatorItem.photoUrls = photoUrls
        indicatorValues.push(indicatorItem)
      } else {
        indicatorItem.photos = []
        indicatorItem.photoUrls = []
        unionindicatorValues.push(indicatorItem)
      }
    })

    let photoUrls = []
    photos.forEach(photo => {
      photo.thumbUrl = photo.url + '/resize,w_100'
      photoUrls.push(photo.url + '/resize,w_1260/quality,q_90')
      photo.url += '/resize,w_1260/quality,q_90'
    })

    let collectPhotoUrls = []
    collectPhotos.forEach(collectPhoto => {
      collectPhoto.thumbUrl = collectPhoto.url + '/resize,w_100'
      collectPhotoUrls.push(collectPhoto.url + '/resize,w_1260/quality,q_90')
      collectPhoto.url += '/resize,w_1260/quality,q_90'
    })

    if (unionindicatorValues.length > 0) {
      unionindicatorValues[0].photos = []
      unionindicatorValues[0].photoUrls = []
    }

    tableRowNode4PlantColumnMerge.push({
      startRowIndex: vo.length,
      needTobeMergedRowCount: 0
    })

    indicatorValues = [].concat(unionindicatorValues, indicatorValues)

    let overviewPhotoUrls = []
    overviewPhotos.forEach(overviewPhoto => {
      overviewPhoto.thumbUrl = overviewPhoto.url + '/resize,w_100'
      overviewPhotoUrls.push(overviewPhoto.url + '/resize,w_1260/quality,q_90')
      overviewPhoto.url += '/resize,w_1260/quality,q_90'
    })

    let deviceID2WorkState = {}
    if (dto.currBoundDevicesState && dto.currBoundDevicesState.length > 0) {
      dto.currBoundDevicesState.forEach(workState => {
        deviceID2WorkState[workState.device.device.id] = workState
      })
    }

    let deviceID2LatestSoilData = {}
    if (dto.soilMonitorData && dto.soilMonitorData.length > 0) {
      dto.soilMonitorData.forEach(soilData => {
        deviceID2LatestSoilData[soilData.deviceID] = soilData
      })
    }

    let currBoundDeviceDescription = ''
    if (dto.currBoundDevices && dto.currBoundDevices.length > 0) {
      dto.currBoundDevices.sort((a, b) => a.device.device.modelId - b.device.device.modelId)
      dto.currBoundDevices.forEach(item => {
        if (currBoundDeviceDescription.length > 0) {
          currBoundDeviceDescription += '，'
        }

        let boundDateDesc = formatTimeInSec(item.bindingList[0].binding.bindTime / 1000, 'yyyy年MM月dd日h点m分') + '绑定'
        currBoundDeviceDescription += item.device.device.serialNumber + ' (' + boundDateDesc

        let workState = deviceID2WorkState[item.device.device.id]
        if (workState) {
          if (workState.remainingBatteryPercentage) {
            currBoundDeviceDescription += '，最近电量' + workState.remainingBatteryPercentage + '%'
          }
          if (workState.latestMonitorDatagramTime) {
            currBoundDeviceDescription += '，监测时间' + formatTimeInSec(workState.latestMonitorDatagramTime / 1000, 'MM月dd日h点m分')
          }
        }

        let soilData = deviceID2LatestSoilData[item.device.device.id]
        if (soilData) {
          if (!isNaN(soilData.humidity)) {
            currBoundDeviceDescription += '，湿度' + Number(soilData.humidity).toFixed(1) + '%'
          }
          if (!isNaN(soilData.temperature)) {
            currBoundDeviceDescription += '，温度' + Number(soilData.temperature).toFixed(1) + '℃'
          }
        }

        currBoundDeviceDescription += ')'
      })
    }

    let rowData = {
      index: (pageNumber - 1) * pageSize + dtoIdx + 1,
      collectMode: dto.collectMode || '',
      collectTime: dto.collectTime || '',
      createTime: dto.createTime || '',
      collectorName: dto.collectorName || '',
      sampleCode: dto.sampleCode || '',
      plotName: (dto.plotName && (dto.plotName + '_' + dto.cropsRotationPlotID)) || '',
      plotArea: dto.plotArea || '',
      plotCounty: dto.plotCounty || '',
      plotMgmtName: dto.plotMgmtName || '',
      plotOwnerName: dto.plotOwnerName || '',
      plotOwnerPhone: dto.plotOwnerPhone || '',
      plotMaxHumidityThetaV: dto.plotMaxHumidityThetaV || '',
      hasCheckedMaxHumidityThetaV: dto.plotMaxHumidityThetaV === 3740 ? '否' : '是',
      remark: dto.remark || '',
      collectPhotos: collectPhotos,
      collectPhotoUrls: collectPhotoUrls,
      overviewPhotos: overviewPhotos,
      overviewPhotoUrls: overviewPhotoUrls,
      currBoundDevices: dto.currBoundDevices || [],
      currBoundDeviceDescription: currBoundDeviceDescription.length > 0 ? currBoundDeviceDescription : '无',
      modificationFlows: dto.modificationFlows || []
    }

    if (indicatorValues.length > 0) {
      indicatorValues[0] = Object.assign(indicatorValues[0], rowData)
    }

    vo = vo.concat(indicatorValues)
  })
  console.log(that.$route.name + ' _convertIndicatorCollectDto2Vo() return', vo)
  return vo
}

const fetchIndicatorCollect = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchIndicatorCollect() params ', params)

  getRequest(URL_COLLECTIONS, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchIndicatorCollect() res', res)
      let collectionList = _convertIndicatorCollectDto2Vo(res.data.pageData, params.pageNumber, params.pageSize)
      callback.onSucc({ totalCount: res.data.totalRecordCount, pageData: collectionList })
    })
    .catch(err => {
      that.isLoading = false
      console.warn(that.$route.name + ' fetchIndicatorCollect() err' + err)
      callback.onFail(err.message || '查询采集记录失败，服务器异常，请稍后重试！')
    })
}

/**
 * 查询巡田信息。
 *
 * @param params {
 *  plotID // 必须 //, creatorName, startTimestamp, endTimestamp, pageNumber // 1-based //, pageSize
 * }
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 * @return 成功时回调的数据结构为 [{ plotID, expertName, expertPhone, patrolTimestamp, fieldCondition, suggestion, remark, photoUrls, thumbnailUrls }]
 */
const fetchFieldPatrol = function (that, params, callback) {
  that.isLoading = true
  console.log(that.$route.name + ' fetchFieldPatrol() params ', params)

  params.rotationalPlotID = params.plotID
  params.performer = params.creatorName
  params.startTimestampIncluded = params.startTimestamp
  params.endTimestampExcluded = params.endTimestamp
  params.pageNumber = params.pageNumber ? params.pageNumber : 1
  params.pageSize = params.pageSize ? params.pageSize : 9999
  params.canopyDieBackOption = 3 // 是否是回秧 查询全部

  getRequest(URL_GET_FIELD_PATROL_RESULTS, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchFieldPatrol() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '服务器异常，请稍后重试！')
        return
      }
      if (!res.data || !Array.isArray(res.data.pageData) || res.data.pageData.length === 0) {
        callback.onSucc([])
        return
      }

      // convert to vo
      let fieldPatrols = []
      res.data.pageData.forEach(fieldPatrolDto => {
        let fieldPatrolVo = {}
        fieldPatrolVo.plotID = fieldPatrolDto.cropsRotationPlotID
        fieldPatrolVo.expertName = fieldPatrolDto.expertName
        fieldPatrolVo.expertPhone = fieldPatrolDto.expertPhone
        fieldPatrolVo.patrolTimestamp = fieldPatrolDto.performTimestamp
        fieldPatrolVo.fieldCondition = fieldPatrolDto.cropCondition
        fieldPatrolVo.suggestion = fieldPatrolDto.suggestion
        fieldPatrolVo.remark = fieldPatrolDto.remark
        fieldPatrolVo.photoUrls = fieldPatrolDto.imageLocations

        fieldPatrolVo.thumbnailUrls = []
        if (Array.isArray(fieldPatrolVo.photoUrls) || fieldPatrolVo.photoUrls.length > 0) {
          fieldPatrolVo.photoUrls.forEach(rawPhotoUrl => {
            fieldPatrolVo.thumbnailUrls.push(rawPhotoUrl + '/resize,w_100')
          })
        }
        fieldPatrols.push(fieldPatrolVo)
      })
      callback.onSucc(fieldPatrols)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchFieldPatrol() err', err)
      callback.onFail(err.message || '服务器异常，请稍后重试！')
    })
}

/**
 * 获取给定地块的所有叶柄检测值的评价。
 * 成功时回调的数据结构为 [{
 *   "indicatorCollectID": 84193,
 *   "collectMonthDay": "6月25日",
 *   "indicators":[{
 *     "evaluation": "偏高", // 偏低，正常
 *     "indicator": "叶柄全钙含量",
 *     "indicatorID": 306,
 *     "value": "4631",
 *   }]
 * }]
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchPetioleIndicatorEvaluation = function (that, params, callback) {
  that.isLoading = params.showLoading
  getRequest(URL_PETIOLE_INDICATOR_EVALUATION, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchPetioleIndicatorEvaluation() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }

      let result = []
      res.data.forEach(dto => {
        if (dto.petioleIndicatorValueEvaluation && dto.petioleIndicatorValueEvaluation.length > 0) {
          let vo = {
            indicatorCollectID: dto.petioleIndicatorValueEvaluation[0].indicatorCollectID,
            collectMonthDay: dto.petioleIndicatorValueEvaluation[0].collectMonthDay,
            indicators: []
          }

          dto.petioleIndicatorValueEvaluation.forEach(indicatorEvDto => {
            vo.indicators.push({
              evaluation: indicatorEvDto.evaluation,
              indicator: indicatorEvDto.indicator,
              indicatorID: indicatorEvDto.indicatorID,
              value: indicatorEvDto.value
            })
          })

          result.push(vo)
        }
      })
      callback.onSucc(result)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchPetioleIndicatorEvaluation() fail', err)
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}
/**
 * fetchPetioleIndicatorEvaluation的多地块版本
 * 成功时回调的数据结构为 {plotID: []}
 */
const fetchPetioleIndicatorEvaluationMultiPlots = function (that, params, callback) {
  that.isLoading = params.showLoading
  getRequest(URL_PETIOLE_INDICATOR_EVALUATION_MULTI_PLOTS, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchPetioleIndicatorEvaluationMultiPlots() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }

      let result = {}
      Object.keys(res.data).forEach(plotID => {
        let resultOfOnePlot = [];
        (res.data[plotID] || []).forEach(dto => {
          if (dto.petioleIndicatorValueEvaluation && dto.petioleIndicatorValueEvaluation.length > 0) {
            let vo = {
              indicatorCollectID: dto.petioleIndicatorValueEvaluation[0].indicatorCollectID,
              collectMonthDay: dto.petioleIndicatorValueEvaluation[0].collectMonthDay,
              indicators: []
            }

            dto.petioleIndicatorValueEvaluation.forEach(indicatorEvDto => {
              vo.indicators.push({
                evaluation: indicatorEvDto.evaluation,
                indicator: indicatorEvDto.indicator,
                indicatorID: indicatorEvDto.indicatorID,
                value: indicatorEvDto.value
              })
            })

            resultOfOnePlot.push(vo)
          }
        })
        result[plotID] = resultOfOnePlot
      })
      callback.onSucc(result)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchPetioleIndicatorEvaluationMultiPlots() fail', err)
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取给定长势指标值的评价。
 * 成功时回调的数据结构为 {
 *  434786: [ // key是指标值的ID
 *    {
 *      "evaluation": "重量正常",
 *      "indicatorValueID": 434786,
 *      "scoreDate": "2023-07-13 "
 *    },
 *    {
 *      "evaluation": "重量增速正常"
 *      "indicatorValueID": 434786,
 *      "scoreDate": "2023-07-13 "
 *    }
 * ]}
 *
 * @param callback 包含 onSucc 和 onFail 两个回调函数
 */
const fetchGrowthIndicatorEvaluation = function (that, params, callback) {
  that.isLoading = params.showLoading
  getRequest(URL_GROWTH_INDICATOR_EVALUATION, params)
    .then(res => {
      that.isLoading = false
      console.log(that.$route.name + ' fetchGrowthIndicatorEvaluation() res', res)

      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      that.isLoading = false
      console.error(that.$route.name + ' fetchGrowthIndicatorEvaluation() fail', err)
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取地块的卫星图像
 * @param params.plotIDs 地茬ID，必填，形如 "123,456,897"
 * @param params.imageTypes 卫星图像类型，例如 "RGB,NDVI"
 * @param params.masCloud 最大云量，百分比，例如 35.8
 *
 * @return
 * [{
 *     "cloudCoverPercent": 0.0,
 *     "coefficientVariation": 0.257399,
 *     "groundSampleDistanceInMeter": 10.0,
 *     "id": 124,
 *     "imageType": "NDVI",
 *     "imageURL": "https://dbx-prod.oss-cn-hangzhou.aliyuncs.com/21761_satellite_NDVI_cdse_sentinel-2c_202503301127.png",
 *     "isOriginal": false,
 *     "meanValue": 0.087116,
 *     "monitorTimestamp": 1743305223261,
 *     "plotID": 21761,
 *     "source": "CDSE",
 *     "sourceCollection": "sentinel-2-l2a",
 *     "sourceSatellite": "sentinel-2c",
 *     "standardDeviation": 0.022424
 *   },......]
 */
const fetchSatelliteImages = function (params, callback) {
  getRequest(URL_SATELLITE_IMAGE, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/**
 * 获取指定地块，在时间段内，所有采集位置的聚类中心，即采集点位最密集的中心位置。
 * @param params.plotIDs 地茬ID，必填，形如 "123,456,897"
 * @param params.beginTimestamp 采集的起始时间，毫秒时间戳，包含
 * @param params.endTimestamp 采集的中止时间，毫秒时间戳，不含
 *
 * @return key为plotID，value为经纬度
 * { '21763': { latitude: 40.68231663730465, longitude: 112.04457765039176} }
 */
const fetchCollectsDensityCenter = function (params, callback) {
  getRequest(URL_COLLECT_DENSITY_CENTER, params)
    .then(res => {
      if (res.code !== 0) {
        callback.onFail(res.message || '查询失败，服务器异常，请稍后重试！')
        return
      }

      if (!res.data) {
        callback.onFail('查询失败，服务器异常，请稍后重试！')
        return
      }
      callback.onSucc(res.data)
    })
    .catch(err => {
      callback.onFail(err.message || '查询失败，服务器异常，请稍后重试！')
    })
}

/** 查询当前设备是Android, iOS还是PC */
const detectDeviceType = function () {
  const userAgent = navigator.userAgent.toLowerCase()

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'iOS'
  }

  if (/android/.test(userAgent)) {
    return 'Android'
  }

  return 'PC'
}

export {
  fetchCropsRotationMeta,
  fetchAvailableCropsRotation,
  fetchGrowthStageMeta,
  fetchFarmListWithPlotAuthorization,
  fetchFarmListWithVarietyStagePlotAuthorization,
  fetchIndicatorHistoryValueAndEvaluation,
  fetchPlotSummaryWithGrowthStage,
  fetchPlotWithCollectDateList,
  fetchPlotListWithBoundary,
  updateFieldBoundary,
  fetchServiceTypeMeta,
  fetchCollectRuleCompanies,
  fetchLatestValues4AllEverCollectedIndicator,
  fetchUser,
  fetchPlotCollectionValueByCollectType,
  fetchfrostTemperature,
  fetchOfficialCompany,
  fetchBossOfCompany,
  fetchFarm,
  fetchPlantingTimeSuggestion,
  fetchPlotAndFarmer,
  fetchPlotPassedGrowthStageList,
  fetchIndicatorCollect,
  fetchFieldPatrol,
  fetchPetioleIndicatorEvaluation,
  fetchPetioleIndicatorEvaluationMultiPlots,
  fetchGrowthIndicatorEvaluation,
  fetchSatelliteImages,
  fetchCollectsDensityCenter,
  detectDeviceType
}



// WEBPACK FOOTER //
// ./src/utils/CommonAPIs.js